import React, { FC } from 'react';
import styled from '@emotion/styled';
import { Flex } from '$components/layouts';
import { IReviewModel } from '$models';
import { IconReview } from '$components/elements/icon-review';

type MediaReviewProps = {
    review: IReviewModel;
};

export const MediaReview: FC<MediaReviewProps> = ({ review }: MediaReviewProps): JSX.Element => {
    return (
        <Review>
            <Quote>{`"${review.quote ? review.quote : review.headline}"`}</Quote>
            <Flex gap="small" alignItems="center">
                {review?.gradingScale?.max === 100 || !review?.gradingScale ? (
                    <GradePercent>{`${review.gradeInProcent}/100`}</GradePercent>
                ) : (
                    <IconReview score={review.gradeRaw || 0} numberOfIcons={review.gradingScale?.max} />
                )}
                {review.url ? (
                    <a href={review.url} rel="nofollow noreferrer" target="_blank">
                        {review.mediaName}
                    </a>
                ) : (
                    <span>{review.mediaName}</span>
                )}
            </Flex>
        </Review>
    );
};

const Review = styled.div(({ theme }) => ({
    marginBottom: theme.space[6],
    fontSize: theme.fontSizes.sm,
}));

const Quote = styled.div(({ theme }) => ({
    marginBottom: theme.space[1],
    fontStyle: 'italic',
}));

const GradePercent = styled.span(({ theme }) => ({
    paddingRight: theme.space[2],
}));
